import QueryString from 'query-string';

export class NavigationService {
    public getLocationId = (): number | null =>  {
        const params = QueryString.parse(window.location.search);
        return params.locationId ? parseInt(params.locationId.toString()) : null;
    }

    public getCustomerId = (): number | null =>  {
        const params = QueryString.parse(window.location.search);
        return params.customerId ? parseInt(params.customerId.toString()) : null;
    }

    public addImpersonationToSearch = (search = ''): string => {
        const locationId = this.getLocationId();
        const customerId = this.getCustomerId();
        const params = QueryString.parse(search);

        if(locationId) {
            params.locationId = locationId.toString();
        }

        if(customerId) {
            params.customerId = customerId.toString();
        }

        return QueryString.stringify(params);
    }

    public addImpersonationToUrl = (url: URL): URL => {
        const locationId = this.getLocationId();
        const customerId = this.getCustomerId();

        if(locationId) {
            url.searchParams.set('locationId', locationId.toString());
        }

        if(customerId) {
            url.searchParams.set('customerId', customerId.toString());
        }

        return url;
    }
}
